import * as React from 'react'
import { Alert, Button, CircularProgress, Snackbar } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import {
  getServicePageFx,
  syncServiceDocumentFx
} from '../../Api/PaidService/servicePage'
import { updateModal } from '../../components/ErrorModal'

export default function DocumentRefreshButton({ serviceId }) {
  const [isRefreshing, setIsRefreshing] = React.useState(false)
  const [notification, setNotification] = React.useState(null)

  const refreshDocument = React.useCallback(async () => {
    setIsRefreshing(true)

    try {
      const response = await syncServiceDocumentFx(serviceId)

      if (!response.data?.success) {
        updateModal(response.data?.errors)
        return
      }

      await getServicePageFx(serviceId)
      setNotification({ severity: 'success', text: 'Данные на карточке обновлены' })
    } catch (error) {
      updateModal(error.response?.data?.errors)
    } finally {
      setIsRefreshing(false)
    }
  }, [serviceId])

  return (
    <>
      <Button
        size="small"
        startIcon={isRefreshing ? <CircularProgress size={14} /> : <RefreshIcon />}
        onClick={refreshDocument}
        disabled={isRefreshing}
      >
        Обновить
      </Button>
      <Snackbar
        open={Boolean(notification)}
        autoHideDuration={4000}
        onClose={() => setNotification(null)}
      >
        <Alert severity={notification?.severity} onClose={() => setNotification(null)}>
          {notification?.text}
        </Alert>
      </Snackbar>
    </>
  )
}
